import React, { CSSProperties, PropsWithChildren } from 'react';
import { Stack } from '@mui/material';
import { RenderWithFallback } from 'components/shared/Conditional/RenderWithFallback';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';
import { SectionHeader } from './SectionHeader';
import { SectionHeaderProps } from '../../types';

interface Props extends SectionHeaderProps {
  sx?: CSSProperties;
}

export const Section = ({
  children,
  sx = {},
  fallBack,
  isLoading = false,
  ...headerProps
}: PropsWithChildren<Props>) => {
  return (
    <Stack gap="0.75rem" sx={sx}>
      <RenderWithFallback isLoading={isLoading} fallBack={fallBack ?? <>Loading</>}>
        <RenderWithCondition condition={!!headerProps.title}>
          <SectionHeader {...headerProps} />
        </RenderWithCondition>

        {children}
      </RenderWithFallback>
    </Stack>
  );
};
